import { Card, CardHeader, CardTitle } from '@/components/ui/card';

const NON_SCORABLE_TYPES = ['Expert opinion', 'Editorial', 'Letter', 'Commentary'];
const EVIDENCE_SYNTHESIS_TYPES = ['Meta-analysis', 'Systematic review', 'Scoping review', 'Narrative review', 'Critical appraisal review'];

export const ImpactScoreCards = ({ article }) => {
  const isCaseReport = article.normalized_study_type === 'Case report' || article.normalized_study_type === 'Case series';
  const isNonScorable = NON_SCORABLE_TYPES.includes(article.normalized_study_type);
  const isEvidenceSynthesis = EVIDENCE_SYNTHESIS_TYPES.includes(article.normalized_study_type);

  const getScoreLabel = () => {
    if (isNonScorable) return null;
    if (isEvidenceSynthesis) return 'Evidence Synthesis Score (max 35)';
    if (isCaseReport) return 'Clinical Value Score (max 35)';
    return 'Methodology Score (max 70)';
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8">
      <Card data-testid="impact-index-card">
        <CardHeader className="py-4 sm:py-6">
          <CardTitle className="text-center">
            <div className="text-4xl sm:text-5xl font-bold text-blue-600 mb-1 sm:mb-2" data-testid="impact-index-value">
              {article.impact_index ? article.impact_index.toFixed(1) : 'N/A'}
            </div>
            <div className="text-xs sm:text-sm font-normal text-slate-600">Impact Index</div>
          </CardTitle>
        </CardHeader>
      </Card>

      <Card data-testid="methodology-score-card">
        <CardHeader className="py-4 sm:py-6">
          <CardTitle className="text-center">
            {isNonScorable ? (
              <>
                <div className="text-4xl sm:text-5xl font-bold text-slate-400 mb-1 sm:mb-2" data-testid="methodology-score-value">N/A</div>
                <div className="text-sm font-normal text-slate-500">Not Scorable</div>
                <div className="text-xs font-normal text-slate-400 mt-1">{article.normalized_study_type} articles are not methodology-scored</div>
              </>
            ) : (
              <>
                <div className={`text-4xl sm:text-5xl font-bold mb-1 sm:mb-2 ${isEvidenceSynthesis ? 'text-teal-600' : 'text-green-600'}`} data-testid="methodology-score-value">
                  {article.methodology_score ? article.methodology_score.toFixed(1) : 'N/A'}
                </div>
                <div className="text-sm font-normal text-slate-600">{getScoreLabel()}</div>
              </>
            )}
          </CardTitle>
        </CardHeader>
      </Card>

      <Card data-testid="visibility-score-card">
        <CardHeader>
          <CardTitle className="text-center">
            <div className="text-5xl font-bold text-purple-600 mb-2" data-testid="visibility-score-value">
              {article.visibility_score !== undefined && article.visibility_score !== null ? article.visibility_score.toFixed(1) : 'N/A'}
            </div>
            <div className="text-sm font-normal text-slate-600">Visibility Score (max 30)</div>
          </CardTitle>
        </CardHeader>
      </Card>
    </div>
  );
};
